import { render, staticRenderFns } from "./TheSidebarRight.vue?vue&type=template&id=68c2026c&scoped=true&"
import script from "./TheSidebarRight.vue?vue&type=script&lang=js&"
export * from "./TheSidebarRight.vue?vue&type=script&lang=js&"
import style0 from "./TheSidebarRight.vue?vue&type=style&index=0&id=68c2026c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c2026c",
  null
  
)

export default component.exports